import { createContext } from "react";

const GipContext = createContext({
  // general loader status
  loading: false,
  gips: [],
  gipsCount: 0,
  countriesCount: 0,
  companiesCount: 0,
  processQuery: () => {},
  activeProject: null,
  setActiveProject: () => {},
});

export default GipContext;
